namespace GeniuzPOS.PosShift {
    export class PsPriceOverrideTranColumns {
        static columnsKey = 'PosShift.PsPriceOverrideTran';
    }
}
